<template>
  <el-collapse v-model="activeIconGroupName" accordion>
    <el-collapse-item title="拖动组件" name="1">
      <ul class="svg-nav-list">
        <li v-for="item in draggableComponentList" :key="item.title">
          <el-tooltip class="item" effect="dark" :content="item.title" placement="bottom">
            <img :src="item.priview_img" draggable="draggable" @mousedown="handleMousedown(item.type,item.title,item.default_attr,item.create_type)">
          </el-tooltip>
        </li>
      </ul>
    </el-collapse-item>
    <el-collapse-item title="绘制组件" name="2">
      <ul class="svg-nav-list">
        <li v-for="item in drawComponentList" :key="item.title">
          <el-tooltip class="item" effect="dark" :content="item.title" placement="bottom">
            <img :src="item.priview_img" draggable="draggable" @mousedown="handleMousedown(item.type,item.title,item.default_attr,item.create_type)">
          </el-tooltip>
        </li>
      </ul>
    </el-collapse-item>
    <el-collapse-item title="图表" name="3">
      <ul class="svg-nav-list">
        <li v-for="item in chartComponentList" :key="item.title">
          <el-tooltip class="item" effect="dark" :content="item.title" placement="bottom">
            <img :title="item.title" :src="item.priview_img" draggable="draggable" @mousedown="handleMousedown(item.type,item.title,item.default_attr,item.create_type)">
          </el-tooltip>
        </li>
      </ul>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
export default {
  data() {
    return {
      activeIconGroupName: '1',
      draggableComponentList: [], // 拖动组件
      drawComponentList: [], // 绘制类型组件
      chartComponentList: [], // 图表类型
      svgInfoData: [] // 接口获取到的组件数据
    }
  },
  watch: {
    'svgInfoData': {
      deep: true,
      handler(val) {
        this.draggableComponentList = val.filter(m => {
          return m.panel_class == 'draggable'
        })
        this.drawComponentList = val.filter(m => {
          return m.panel_class == 'draw'
        })
        this.chartComponentList = val.filter(m => {
          return m.panel_class == 'chart'
        })
      }
    }
  },
  created() {
    this.loadSvgIcons()
  },
  methods: {
    // 左侧图标看板开始
    async loadSvgIcons() {
      this.svgInfoData = await this.$store.dispatch('loadNoramlSvgIcons')
      this.$emit('svgInfoData', this.svgInfoData)
    },
    /**
         * @description: 点击左侧工具栏触发函数
         * @param {*} type
         * @param {*} title
         * @param {*} default_attr 属性默认值
         * @param {*} create_type 组件创建方式
         * @return {*}
         */
    handleMousedown(type, title, default_attr, create_type) {
      const currentlySelectedToolBar = {
        Type: type, // 选中的工具栏svg类型
        TypeName: title, // 选中的工具栏svg类型名称
        Title: title, // 选中的工具栏svg标题
        Color: default_attr.color, // 选中的工具栏svg颜色
        CreateType: create_type, // 选中工具栏的创建方式
        EChartsOption: default_attr.echarts_option,
        Ia: default_attr.Ia,
        Ib: default_attr.Ib,
        Ic: default_attr.Ic,
        zxyg: default_attr.zxyg
      }
      this.$store.dispatch('setCurrentlySelectedToolBarAction', currentlySelectedToolBar)
    }
    // 左侧图标看板结束
  }
}
</script>
